<template>
  <div>
    <button type="button" @click="$emit('clicked')" :class="btnCssClass" :disabled="btnDisabled">
      <span v-if="prevM"> <span class="icon icon-navigation_pfeil_links" aria-hidden="true"></span> <span class="sr-only">{{ $t(i18nMessage, i18nCount) }}</span></span>
      <span v-else-if="nextM"> <span class="icon icon-navigation_pfeil_rechts" aria-hidden="true"></span> <span class="sr-only">{{ $t(i18nMessage, i18nCount) }}</span></span>
      <span v-else>{{ $t(i18nMessage, i18nCount) }}</span>
    </button>
  </div>
</template>

<script lang="ts">
import { CssColorClass } from '@/models/CssColorClass';
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ButtonAction',
  props: {
    i18nMessage: {
      type: String,
      required: true
    },
    i18nCount: {
      type: Number,
      required: false,
      default: 1
    },
    prevM: Boolean,
    nextM: Boolean,
    btnOutline: Boolean,
    btnDisabled: Boolean,
    btnCssColorClass: {
      type: String,
      default: CssColorClass.brand1
    }
  },
  computed: {
    btnCssClass(): string {
      let cssClass = "btn btn-"
      cssClass += (this.btnOutline ? 'outline-' : '')
      cssClass += this.btnCssColorClass
      return cssClass
    }

  }
});
</script>
